import {DetailsList, PrimaryButton, SearchBox, SelectionMode} from "@fluentui/react";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {Link, useParams} from 'react-router-dom';
import AppContent from "../Surfaces/AppContent";
import AuthContext from "../Services/AuthContext";
import {whitespaceMatcher} from "../Utilities/WhitespaceMatcher";
import { netGrossColumn, useNetGross } from "../Utilities/NetGrossField";

function AgreementCategoryVentures(props) {
    const [user] = useContext(AuthContext);
    const netGross = useNetGross();
    const [ventures, setVentures] = useState([]);
    const [name, setName] = useState([]);
    const [filteredVentures, setFilteredVentures] = useState([]);
    const [filter, setFilter] = useState('');

    const params = useParams();
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch(`/api/agreement_category/${params.id}`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { setName(data[0].category); setVentures(data);})
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [params, user.token]);

    useEffect(() => {
        setFilteredVentures(ventures.filter(item => whitespaceMatcher(filter, [item.venture].join(' '))));
        return filteredVentures;
    }, [filter, ventures]);

    const [columns, setColumns] = useState([]);

    useEffect(() => {
        setColumns([
            {
                key: 'venture',
                name: 'Kontrakt',
                ariaLabel: 'Kontrakt',
                fieldName: 'venture',
                minWidth: 200,
                isResizable: true,
                isRowHeader: true,
                onRender: (item) => (<Link to={`/venture/${item.venture_id}`}><PrimaryButton text={`${item.venture}`}/></Link>)
            },
            {
                minWidth: 120,
                ...netGrossColumn('', 'value', 'Wartość ')
            }
        ]);
    }, [netGross]);


    return (
        <AppContent title={`Kategoria Umowowy: ${name}`} backTo={`/agreement_category`}>
            <SearchBox placeholder="Wyszukaj" value={filter} onChange={(e, value) => setFilter(value)} />
            <DetailsList items={filteredVentures} columns={columns} selectionMode={SelectionMode.none} constrainMode={0}/>
        </AppContent>
    );
}

export default AgreementCategoryVentures;